import { render, staticRenderFns } from "./ValueColumn.vue?vue&type=template&id=524540ec&scoped=true&"
import script from "./ValueColumn.vue?vue&type=script&lang=ts&"
export * from "./ValueColumn.vue?vue&type=script&lang=ts&"
import style0 from "./ValueColumn.vue?vue&type=style&index=0&id=524540ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524540ec",
  null
  
)

export default component.exports